import {Call} from "./Call";


export function formatCallPhoneNumber(call: Pick<Call, 'number'>): string {
    if (call.number === "ANONYMOUS") {
        return "Anoniem"
    }
    return call.number.number.replace('tel:', '')
}